import * as React from "react";
import { connect } from "react-redux";

import { SSTable } from "../common/TableData";

function VenueMapTab({ venues, venuesMap, onChange }) {
  const unmappedVenues = Object.keys(venues || {}).filter(
    (v) => venues[v].isNew,
  ).length;

  return (
    <div>
      <SSTable>
        <thead>
          <tr>
            <td>Name</td>
            <td>Binding</td>
          </tr>
        </thead>
        <tbody>
          {Object.keys(venues || {}).map((v) => (
            <tr
              key={v}
              style={{
                backgroundColor: venues[v].isNew ? "rgb(255,0,0,0.25)" : "",
              }}
            >
              <td>{venues[v].name}</td>
              <td>
                {v in venuesMap ? venuesMap[v].name : "Error, correct name"}{" "}
              </td>
              {/* <td style={{width: "200px"}}><VenuesSelector
                        venueId={venues[v]._id}
                        extraItems={[{label: "Create venue", value: ""}]}
                        onChange={(venueId) => onChange(v, venueId.length > 0 ? {
                            isNew: false,
                            _id: venueId
                        } : {isNew: true, _id: v})}
                    /></td> */}
            </tr>
          ))}
        </tbody>
      </SSTable>
    </div>
  );
}

function mapStateToProps(state, props) {
  return {
    venuesMap: state.venues.map,
  };
}

function mapDispatchToProps(dispatch) {
  return {};
}

export default connect(mapStateToProps, mapDispatchToProps)(VenueMapTab);
